module.exports = __webpack_public_path__ + "img/021-smartphone.34b6343a.svg";